import { all, call, fork, put, takeEvery } from 'redux-saga/effects';

// actions
import { doneIndicator, error } from '../../actions/standardActions';

// api
import managerAPI from '../../sources/api/managerAPI';

// constants
import { CURRENT_MANAGER_UPDATE } from '../../constants/currentManagerTypes';

// lib
import handleServerValidation from '../../lib/handleServerValidation';
import httpSaga from '../../lib/httpSaga';
import { toastr } from 'react-redux-toastr';
import { DATA_EDIT_ERROR, DATA_EDIT_SUCCESS } from '../../constants/messages';

export function* currentManagerUpdate(action) {
  if (action['@@redux-saga/SAGA_ACTION']) return;

  const params       = action.payload;
  const officeParams = params.office || {};

  if (officeParams.phoneNumber) {
    officeParams.phoneNumber = `+1${officeParams.phoneNumber.replace(/\D+/g, '')}`;
  }

  try {
    yield *httpSaga(CURRENT_MANAGER_UPDATE, call(managerAPI.updateSelf, params));
    yield toastr.success('Success', DATA_EDIT_SUCCESS);
  } catch (e) {
    const errors = handleServerValidation('manager', e.response.body.details, { nestedPath: true });

    yield toastr.error(DATA_EDIT_ERROR);
    yield put(error(CURRENT_MANAGER_UPDATE, errors));
  } finally {
    yield put(doneIndicator(CURRENT_MANAGER_UPDATE));
  }
}

export function* watchCurrentManagerUpdate() {
  yield takeEvery(CURRENT_MANAGER_UPDATE, currentManagerUpdate);
}

export default function* root() {
  yield all([
    fork(watchCurrentManagerUpdate)
  ]);
}



// WEBPACK FOOTER //
// ./app/sagas/manager/currentManagerUpdate.js